import { ErrorMessageStyled } from "components/primitives/TextArea";
import { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface NumberInputInfo {
  label: string;
  minValue?: number;
  maxValue?: number;
  wholeNumbers?: boolean;
  value?: number;
  isGroupMaker?: boolean;
}

export const NumberInputSetting: WidgetSettingFC<number, NumberInputInfo> = ({
  data,
  setData,
  settings,
  info: { label, minValue, maxValue, value, wholeNumbers = false, isGroupMaker },
}) => {
  const [internalValue, setInternalValue] = useState<string>(String(data));
  const isNumber = !isNaN(Number(internalValue)) && internalValue !== "";

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(String(value));
    }
  }, [value, maxValue]);
  const setValue = useCallback(
    (value: string) => {
      if (value.trim() !== "") {
        let number = Number(value);
        if (number !== undefined && !isNaN(number)) {
          if (minValue !== undefined && number < minValue) {
            number = isGroupMaker ? number : minValue;
          }
          if (maxValue !== undefined && number > maxValue) {
            number = isGroupMaker ? number : maxValue;
          }

          if (!wholeNumbers || Number.isInteger(number)) {
            setData(number);
          }
        }
      }
    },
    [maxValue, minValue, setData, wholeNumbers],
  );
  useEffect(() => {
    setValue(internalValue);
  }, [internalValue]);

  return (
    <OuterContainer>
      {settings?.groupingMode === "Auto" && (
        <>
          <MainLabel>{label}</MainLabel>
          {(minValue || maxValue) && (
            <SecondaryLabel>{`(${
              minValue !== undefined ? "Min. " + minValue : ""
            }${minValue !== undefined && maxValue !== undefined ? " - " : ""}${
              maxValue !== undefined ? "Max. " + maxValue : ""
            })`}</SecondaryLabel>
          )}
          <TextForm
            type="text"
            value={internalValue}
            onChange={(e: React.ChangeEvent<any>) => {
              setInternalValue(e.target.value);
              if (isGroupMaker && !e.target?.value) {
                setData(0);
              }
            }}
            isDisabled={settings?.groupingMode === "Auto" ? false : true}
            isInvalid={
              !isNumber ||
              (Boolean(maxValue) && Number(internalValue) > maxValue!) ||
              (Boolean(minValue) && Number(internalValue) < minValue!) ||
              (wholeNumbers && !Number.isInteger(Number(internalValue)))
            }
          />
        </>
      )}
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  margin-bottom: 35px;
`;

const MainLabel = styled.p`
  font-size: 12pt;
  font-weight: 600;
  color: var(--secondary);
`;

const SecondaryLabel = styled.p`
  color: gray;
`;

const TextForm = styled(Form.Control)`
  border: 2px solid var(--secondary);
`;
